import { useShouldShowDevTeamFeature } from './_base';

export const useEventInsightsFeatureToggle = useShouldShowDevTeamFeature;
